import { render } from "./IconPDF.vue?vue&type=template&id=472bee6f&scoped=true"
const script = {}

import "./IconPDF.vue?vue&type=style&index=0&id=472bee6f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-472bee6f"

export default script